export default __webpack_public_path__ + "static/media/Background_00103.559aa256.png";